import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createIndexedDbStorage } from '@/utils/storage/indexeddb-storage';

const initialValues = {
  shippingAddress: null,
  openShippingInfoModal: false,
  shippingMethod: null,
  userLatAndLng: {},
  activeStep: 'shippingMethod',
  selectedAddressToEdit: {},
  unavailableItems: [],
  availableBranches: [],
  isLoadingAvailableBranches: false,
  _hasHydrated: false,
};

const useShippingInfoStore = create(
  persist(
    (set) => ({
      ...initialValues,
      refetchAddressesAfterAddEdit: () => { },
      // hydration flag
      setHasHydrated: (state) => set({ _hasHydrated: state }),

      setShippingAddress: (address) =>
        set(() => ({ shippingAddress: address })),
      setUserLatAndLng: (userLatAndLng) => set(() => ({ userLatAndLng })),
      setShippingMethod: (shippingMethod) =>
        set(() => ({ shippingMethod, shippingAddress: null })),
      setIsOpenShippingInfoModal: (isOpen) =>
        set(() => ({ openShippingInfoModal: isOpen })),
      setActiveStep: (activeStep) => set(() => ({ activeStep })),
      setRefetchAddresses: (refetchAddresses) =>
        set(() => ({ refetchAddressesAfterAddEdit: refetchAddresses })),
      setSelectedAddressToEdit: (selectedAddressToEdit) =>
        set(() => ({ selectedAddressToEdit })),
      setUnavailableItems: (items) => set(() => ({ unavailableItems: items })),
      setAvailableBranches: (branches) =>
        set(() => ({ availableBranches: branches })),
      setIsLoadingAvailableBranches: (loading) =>
        set(() => ({ isLoadingAvailableBranches: loading })),

      clearShippingInfo: () => set(initialValues),
    }),
    {
      name: 'shipping-info',
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
      storage: createIndexedDbStorage('shipping-info'),
    }
  )
);

export default useShippingInfoStore;
